var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 21.4352H14.8C14.634 21.4352 14.5 21.3012 14.5 21.1352V16.9352C14.5 15.5542 13.381 14.4352 12 14.4352C10.619 14.4352 9.5 15.5542 9.5 16.9352V21.1352C9.5 21.3012 9.36595 21.4352 9.19995 21.4352H6C4 21.4352 3 20.4352 3 18.4352V12.0862C3 10.0882 3.52305 9.78126 4.43005 9.02126L10.394 4.02016C11.323 3.24116 12.6781 3.24116 13.6071 4.02016L19.571 9.02126C20.477 9.78126 21.001 10.0882 21.001 12.0862V18.4352C21 20.4352 20 21.4352 18 21.4352Z",
    fill: "#707496"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ed09043e4828c64781c0e0a1613772a6.svg";
export { ForwardRef as ReactComponent };